import { useState } from "react";
import { Button } from "@";

type ManualVerificationDropdownProps = {
  onSubmit: (orderId: number) => Promise<void>;
  isLoading: boolean;
};

export default function ManualVerificationDropdown({
  onSubmit,
  isLoading,
}: ManualVerificationDropdownProps) {
  const [orderId, setOrderId] = useState("");

  const handleSubmit = async () => {
    const parsed = parseInt(orderId);
    if (!parsed || isNaN(parsed) || parsed <= 0) return;
    await onSubmit(parsed);
    setOrderId("");
  };

  return (
    <>
      <button
        type="button"
        id="manual-verification-dropdown-btn"
        data-dropdown-toggle="manual-verification-dropdown"
        className="btn-outline-green flex items-center"
      >
        إنشاء توثيق يدوي
      </button>

      <div
        id="manual-verification-dropdown"
        className="z-10 hidden w-80 overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 shadow-xl"
      >
        <div className="mb-3">
          <label htmlFor="manual-verification-order-id" className="sr-only">
            رقم الطلب
          </label>
          <input
            min={0}
            type="number"
            id="manual-verification-order-id"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            className="input h-12 border border-gray-300"
            placeholder="أدخل رقم الطلب"
          />
        </div>
        <div>
          <Button
            type="button"
            title="إنشاء"
            isLoading={isLoading}
            disabled={!orderId}
            onClick={handleSubmit}
            className="btn-green w-full"
          />
        </div>
      </div>
    </>
  );
}
